/*
 * The create-time preset catalogue.
 *
 * This list mirrors what the platform seeds, and it lives in the CLIENT because
 * the API publishes no catalogue: `preset_key` is a free string on
 * `POST /v1/knowledge-bases`, an unusable key comes back as a bare 400, and there
 * is no route that enumerates the usable ones. Recorded in `API-GAPS.md`.
 *
 * Two consequences are handled rather than hidden. A preset an operator added is
 * not in this list, so the dialog also accepts a key typed by hand. And a key that
 * looks right here can still be refused — the 400 is rendered as "this preset is
 * not available" against the field, not as a failed request.
 *
 * When a catalogue endpoint lands, `usablePresets()` becomes a fetch and this
 * array goes away; nothing else changes.
 */

export interface Preset {
  key: string
  name: string
  description: string
}

export const SEEDED_PRESETS: Preset[] = [
  {
    key: 'general',
    name: 'Общий',
    description:
      'Сбалансированный старт: источники, то, о чём они, идеи, которые они закрепляют, и своды по ним.',
  },
  {
    key: 'research',
    name: 'Исследования',
    description:
      'Статьи и препринты: что заявлено, как измерено, что это значит и какие вопросы остались открытыми.',
  },
  {
    key: 'book',
    name: 'Книги и лонгриды',
    description:
      'Материал, который читается неделями: заметки по главам, идеи, которые из них вырастают, и аргумент целиком.',
  },
  {
    key: 'codebase',
    name: 'Система и код',
    description:
      'Техдокументация: из каких частей состоит система, какие между ними контракты, почему так и как это эксплуатировать.',
  },
  {
    key: 'product',
    name: 'Продукт и рынок',
    description:
      'Что решили, что говорят клиенты, что делают конкуренты и что показывают цифры.',
  },
  {
    key: 'personal',
    name: 'Личное',
    description: 'Свои материалы: заметки, люди и проекты вокруг них, периодические ревью.',
  },
]

/** The key `POST /v1/knowledge-bases` uses when the body omits one. */
export const DEFAULT_PRESET_KEY = 'general'

export function usablePresets(): Preset[] {
  return SEEDED_PRESETS
}

export function presetName(key: string): string {
  return SEEDED_PRESETS.find((preset) => preset.key === key)?.name ?? key
}
